/*
 * @Author: Zhouqi
 * @Date: 2025-12-12 17:00:00
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-12 17:00:00
 */

const VoiceCloningSkeleton = () => {
  return (
    <div className="relative flex p-[16px] h-full bg-[#f7f7f7] box-border overflow-hidden">
      {/* 左侧操作面板 */}
      <div className="w-[328px] relative bg-[#ffffff] rounded-[8px] overflow-x-hidden flex flex-col">
        {/* Tabs 骨架 */}
        <div className="flex border-b border-gray-100 px-[24px]">
          {[...Array(2)].map((_, index) => (
            <div key={index} className="py-[16px] mr-[40px]">
              <div className="relative h-[16px] bg-gray-200 rounded-[4px] w-[60px] overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
            </div>
          ))}
        </div>

        {/* 表单区域 */}
        <div className="flex-1 p-[24px] overflow-auto">
          <div className="flex flex-col gap-[24px]">
            {/* 文本输入区域骨架 */}
            <div className="flex flex-col gap-[8px]">
              <div className="relative h-[16px] bg-gray-200 rounded-[4px] max-w-[80px] overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
              <div className="relative h-[160px] bg-gray-200 rounded-[6px] overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
            </div>

            {/* 声音选择/上传骨架 */}
            <div className="flex flex-col gap-[12px]">
              <div className="relative h-[16px] bg-gray-200 rounded-[4px] max-w-[100px] overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
              <div className="relative h-[48px] bg-gray-200 rounded-[6px] overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
            </div>

            {/* 其他选项骨架 */}
            <div className="flex flex-col gap-[16px]">
              {[...Array(2)].map((_, index) => (
                <div key={index} className="flex flex-col gap-[8px]">
                  <div className="relative h-[14px] bg-gray-200 rounded-[4px] max-w-[60px] overflow-hidden">
                    <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                  </div>
                  <div className="relative h-[32px] bg-gray-200 rounded-[6px] overflow-hidden">
                    <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 底部按钮区域 */}
        <div className="p-[24px] border-t border-gray-200">
          <div className="relative h-[44px] bg-gray-200 rounded-[6px] overflow-hidden">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
          </div>
        </div>
      </div>

      {/* 右侧任务面板 */}
      <div className="flex-1 ml-[16px] relative bg-[#ffffff] rounded-[8px] overflow-hidden flex flex-col p-[24px]">
        {/* 任务列表标题 */}
        <div className="mb-[24px]">
          <div className="relative h-[20px] bg-gray-200 rounded-[4px] max-w-[120px] overflow-hidden">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
          </div>
        </div>

        {/* 任务列表项 */}
        <div className="flex flex-col gap-[16px]">
          {[...Array(3)].map((_, index) => (
            <div
              key={index}
              className="flex gap-[16px] p-[16px] border border-gray-100 rounded-[8px]"
            >
              {/* 缩略图 */}
              <div className="relative w-[120px] h-[68px] bg-gray-200 rounded-[4px] overflow-hidden flex-shrink-0">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
              {/* 内容 */}
              <div className="flex-1 flex flex-col justify-between py-[4px]">
                <div className="flex flex-col gap-[8px]">
                  <div className="relative h-[16px] bg-gray-200 rounded-[4px] w-[60%] overflow-hidden">
                    <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                  </div>
                  <div className="relative h-[14px] bg-gray-200 rounded-[4px] w-[40%] overflow-hidden">
                    <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes shimmer {
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </div>
  );
};

export default VoiceCloningSkeleton;
